import { t } from '../../translate';
import { DominoBuilderError, DominoBuilderErrorScope, DominoBuilderErrorSeverity, DominoBuilderErrorType, } from '../../errors';
export function validateDefinition(definition) {
    const err = [];
    if (!definition.name) {
        err.push(new DominoBuilderError(DominoBuilderErrorType.MissingPropertyWarning, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.ERROR, t('errors.definitions.trigger_variables.name_required'), {
            path: `Global`,
        }));
    }
    if (!definition.spec) {
        err.push(new DominoBuilderError(DominoBuilderErrorType.ParseError, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.FATAL, t('errors.definitions.spec_required'), {
            path: `Global`,
        }));
    }
    return err;
}
export function validateFlowSpecification(spec) {
    const err = [];
    if (!spec.trigger) {
        err.push(new DominoBuilderError(DominoBuilderErrorType.MissingPropertyWarning, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.FATAL, t('errors.definition.trigger_required'), {
            path: `Global`,
        }));
    }
    if (!spec.hasOwnProperty('actions')) {
        err.push(new DominoBuilderError(DominoBuilderErrorType.MissingPropertyWarning, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.FATAL, "Flow spec must contain: 'actions'", {
            path: `Global`,
        }));
    }
    return err;
}
export function validateDerivedFlowSpecification(spec) {
    const err = [];
    if (!spec.blueprintRef) {
        err.push(new DominoBuilderError(DominoBuilderErrorType.MissingPropertyWarning, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.FATAL, "Flow spec must contain: 'blueprintRef'", {
            path: `Global`,
        }));
    }
    return err;
}
//# sourceMappingURL=definitions.js.map